import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export const ROW_HEIGHT = 34;
export const HEADER_HEIGHT = 42;

export default makeStyles((theme: MuiTheme) => ({
  accordion: {
    "& .MuiCollapse-container": {
      padding: "20px 15px 10px 10px",
      margin: -8
    },
    paddingBottom: 10
  },
  eidHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 16px 8px",
    height: HEADER_HEIGHT
  },
  eidTitle: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: "rgba(0, 0, 0, 0.35)"
  },
  eidTitleLight: {
    color: theme.palette.text.primary
  },
  eidTableRowSpecific: {
    backgroundColor: "rgba(238, 238, 238, 0.25)"
  },
  eidTableCell: {
    fontSize: 12,
    height: ROW_HEIGHT
  },
  table: {
    borderBottom: "1px solid #eeeeee"
  },
  tableContainer: {
    flex: "auto"
  },
  emptyDataHolder: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#c3c3c3",
    fontSize: 14
  }
}));
